<template>
  <v-card class="px-4 pt-4 pb-6">
    <div class="mb-6">
      <v-switch
        v-model="localValue.enableEdrEnforcement"
        :disabled="actionNotAllowed"
        :ripple="false"
        color="primary lighten-1"
        data-testid="edr-enforcement-switch"
        hide-details
        inset
      >
        <template #label>
          <div class="subtitle1">
            {{ $t("edr.settings.enableEdrEnforcement") }}
          </div>
        </template>
      </v-switch>
      <p
        class="body2"
        :class="localValue.enableEdrEnforcement ? 'text-medium-emphasis' : 'text-disabled'"
      >
        {{ $t("edr.settings.enableEdrEnforcementDescription") }}
      </p>
    </div>

    <v-checkbox
      v-model="localValue.asrRulesEnabled"
      :disabled="isEdrEnforcementDisabled"
      :ripple="false"
      data-testid="edr-asr-rules-checkbox"
    >
      <template #label>
        <div class="subtitle1">
          {{ $t("edr.settings.asrRules") }}
        </div>
      </template>
    </v-checkbox>
    <div class="ml-7">
      <div
        class="body2"
        :class="isEdrEnforcementDisabled ? 'text-disabled' : 'text-indigo-medium'"
        data-testid="edr-asr-rules-description"
      >
        {{ $t("edr.settings.asrRulesDescription") }}
      </div>
      <template v-if="localValue.asrRulesEnabled">
        <v-autocomplete
          v-model="localValue.asrRulesLabels"
          class="mt-4"
          :items="labels"
          :label="deviceLabelsLabel(localValue.asrRulesLabels?.length)"
          :placeholder="$t('devicesSettings.settingsCard.deviceLabelsPlaceholder')"
          :disabled="isEdrEnforcementDisabled"
          variant="outlined"
          multiple
          return-object
          data-testid="edr-asr-rules-labels"
          item-value="id"
          item-title="name"
          hide-details="auto"
        >
          <template v-slot:chip="{ props, item }">
            <v-chip
              v-bind="props"
              :closable="true"
              size="default"
              :color="item.raw.color"
              :disabled="isEdrEnforcementDisabled"
              close-icon="$x"
              label
              rounded="3"
              variant="flat"
              :text="item.raw.name"
            >
              <span class="coro-label text-uppercase text-primary">
                {{ item.raw.name }}
              </span>
            </v-chip>
          </template>
          <template #item="{ item, props }">
            <v-list-item v-bind="props" class="label-popup-block" title="">
              <div class="d-flex align-center">
                <span class="color-preview mr-2" :style="{ 'background-color': item.raw.color }" />
                <span :data-testid="`edr-asr-rules-${kebabCase(item.raw.name)}-select-item`">
                  {{ item.raw.name }}
                </span>
              </div>
            </v-list-item>
          </template>
        </v-autocomplete>

        <div class="d-flex align-center pl-4 mt-1">
          <v-icon class="mr-1" size="18" icon="$circleCheck" />
          <span class="caption text-green-dark">
            {{ $t("devicesSettings.settingsCard.labelsFieldHint") }}
          </span>
        </div>
      </template>
    </div>
    <!--@TODO uncomment when BE will be ready-->
    <!--    <v-divider />-->
    <!--    <div class="my-6" :class="{ disabled: !localValue.enableEdrEnforcement }">-->
    <!--      <div-->
    <!--        class="subtitle1 mb-2"-->
    <!--        :class="localValue.enableEdrEnforcement ? 'text-primary' : 'text-disabled'"-->
    <!--      >-->
    <!--        {{ $t("edr.settings.remediationMode") }}-->
    <!--      </div>-->
    <!--      <div-->
    <!--        class="body2 mb-4"-->
    <!--        :class="localValue.enableEdrEnforcement ? 'text-medium-emphasis' : 'text-disabled'"-->
    <!--        v-html="$t('edr.settings.remediationModeDescription')"-->
    <!--      />-->
    <!--      <div class="coro-btn-group">-->
    <!--        <v-btn-toggle-->
    <!--          v-model="localValue.remediationMode"-->
    <!--          :disabled="!localValue.enableEdrEnforcement || actionNotAllowed"-->
    <!--          data-testid="remediation-type-btn-toggle"-->
    <!--        >-->
    <!--          <v-btn-->
    <!--            v-for="mode in remediationModes"-->
    <!--            :key="mode"-->
    <!--            :value="mode"-->
    <!--            :data-testid="`remediation-mode-${mode}`"-->
    <!--          >-->
    <!--            {{ $t(`edr.settings.remediationModes.${mode}`) }}-->
    <!--          </v-btn>-->
    <!--        </v-btn-toggle>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="mb-6" :class="{ disabled: !localValue.enableEdrEnforcement }">-->
    <!--      <div-->
    <!--        class="subtitle1 mb-2"-->
    <!--        :class="localValue.enableEdrEnforcement ? 'text-primary' : 'text-disabled'"-->
    <!--      >-->
    <!--        {{ $t("edr.settings.deviceLabels") }}-->
    <!--      </div>-->
    <!--      <v-autocomplete-->
    <!--        v-model="localValue.labels"-->
    <!--        :items="labels"-->
    <!--        :placeholder="$t('edr.settings.deviceLabelsPlaceholder')"-->
    <!--        variant="outlined"-->
    <!--        multiple-->
    <!--        return-object-->
    <!--        chips-->
    <!--        closable-chips-->
    <!--        clear-on-select-->
    <!--        data-testid="labels-autocomplete"-->
    <!--        item-value="id"-->
    <!--        item-title="name"-->
    <!--        :disabled="!localValue.enableEdrEnforcement || actionNotAllowed"-->
    <!--      >-->
    <!--        <template v-slot:chip="{ props, item }">-->
    <!--          <v-chip-->
    <!--            v-bind="props"-->
    <!--            :closable="true"-->
    <!--            variant="flat"-->
    <!--            size="default"-->
    <!--            close-icon="$closeCircle"-->
    <!--            :text="item.raw.name"-->
    <!--            class="label-chip"-->
    <!--            label-->
    <!--            rounded="3"-->
    <!--            :color="item.raw.color"-->
    <!--          >-->
    <!--            <div class="d-flex align-center">-->
    <!--              <span class="ml-1 mr-2 coro-label text-primary text-uppercase" v-text="item.title" />-->
    <!--            </div>-->
    <!--          </v-chip>-->
    <!--        </template>-->
    <!--        <template v-slot:item="{ item, props }">-->
    <!--          <v-list-item v-bind="props" title="">-->
    <!--            <template #default>-->
    <!--              <div class="d-flex align-center label-popup-block">-->
    <!--                <div class="color-preview mr-2" :style="{ 'background-color': item.raw.color }" />-->
    <!--                <span v-text="item.raw.name" />-->
    <!--              </div>-->
    <!--            </template>-->
    <!--          </v-list-item>-->
    <!--        </template>-->
    <!--      </v-autocomplete>-->
    <!--    </div>-->
  </v-card>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { useI18n } from "vue-i18n";
import kebabCase from "lodash/kebabCase";
import type { EdrSettings } from "@/_store/edr-settings.module";
import type { DeviceLabel } from "@/_store/devices-settings.module";
import { EdrRemediationMode } from "@/constants/edr";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<EdrSettings>,
      required: true,
    },
    labels: {
      type: Array as PropType<DeviceLabel[]>,
      default: () => [],
    },
    actionNotAllowed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const i18n = useI18n();
    const localValue = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const remediationModes = [
      EdrRemediationMode.DETECT_ONLY,
      EdrRemediationMode.TERMINATE_PROCESSES,
    ];

    // Policies on this page are gated behind the EDR monitoring toggle.
    const isEdrEnforcementDisabled = computed(() => {
      return props.actionNotAllowed || !localValue.value.enableEdrEnforcement;
    });

    const deviceLabelsLabel = (labelsLength: number) => {
      return labelsLength ? i18n.t("devicesSettings.settingsCard.deviceLabelsLabel") : "";
    };

    return {
      localValue,
      remediationModes,
      isEdrEnforcementDisabled,
      deviceLabelsLabel,
      kebabCase,
    };
  },
});
</script>

<style scoped lang="scss">
.label-popup-block {
  .v-list-item__content {
    display: flex;
    align-items: center;
  }
}

.color-preview {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  border-radius: 2px !important;
}
</style>
